import React from 'react';
import './AgentCard.css';
import agentPic from '../../assets/Agent.png';
import callIcon from '../../assets/call.png';
import msgIcon from '../../assets/message.png';
import starIcon from '../../assets/star.png'; // Make sure this exists in assets

const AgentCard = () => {
  return (
    <div className="agent-card-container">
      <h3 className="card-heading">Contact Agent</h3>
      <div className="agent-profile">
        <img src={agentPic} alt="Agent" className="agent-photo" />
        <div className="agent-details">
          <h4>Sarah Johnson</h4>
          <p>Senior Property Agent</p>
          <div className="rating-row">
            <div className="stars-group">
              {[...Array(5)].map((_, i) => (
                <img key={i} src={starIcon} alt="star" className="star-img" />
              ))}
            </div>
            <span className="review-count">(127 reviews)</span>
          </div>
        </div>
      </div>
      <div className="agent-actions">
        <button className="agent-btn-solid2">
          <img src={callIcon} alt="call" /> Call Agent
        </button>
        <button className="agent-btn-solid">
          <img src={msgIcon} alt="msg" /> Send Message
        </button>
      </div>
      <div className="agent-footer-info">
        <p><img src={callIcon} className="mini-icon" alt="phone" /> +20 2 2735 1234</p>
        <p><img src={msgIcon} className="mini-icon" alt="email" /> sarah.j@bickora.com</p>
      </div>
    </div>
  );
};

export default AgentCard;